var render, staticRenderFns
import script from "./QuickMitsumoriContent.vue?vue&type=script&lang=ts&"
export * from "./QuickMitsumoriContent.vue?vue&type=script&lang=ts&"
import style0 from "./QuickMitsumoriContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuickMitsumoriContent.vue?vue&type=style&index=1&id=0c8cfca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8cfca6",
  null
  
)

export default component.exports